import { UnmatchedBankTransaction } from '@app/fin-ops/models/responses/unmatched-bank-transaction';
import { UnmatchedLedgerTransaction } from '@app/fin-ops/models/responses/unmatched-ledger-transaction';

export interface ReconcileTransactionsRequest {
  bankTransactions: number[];
  ledgerTransactions: number[];
  matchType: MatchType;
}

export const getAreTransactionsBalanced = (
  debitBankTransactions: UnmatchedBankTransaction[],
  debitLedgerTransactions: UnmatchedLedgerTransaction[],
  creditBankTransactions: UnmatchedBankTransaction[],
  creditLedgerTransactions: UnmatchedLedgerTransaction[],
): boolean => {
  const tolerance = 0.001;
  const creditBankTotal = creditBankTransactions.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );
  const creditLedgerTotal = creditLedgerTransactions.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );

  const debitBankTotal = debitBankTransactions.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );
  const debitLedgerTotal = debitLedgerTransactions.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );
  return debitLedgerTransactions.length + creditLedgerTransactions.length > 0
    ? debitBankTransactions.length + creditBankTransactions.length > 0
      ? Math.abs(creditLedgerTotal - creditBankTotal) <= tolerance &&
        Math.abs(debitLedgerTotal - debitBankTotal) <= tolerance
      : Math.abs(creditLedgerTotal + debitLedgerTotal) <= tolerance
    : false;
};
export enum MatchType {
  Manual = 1,
  Automatic = 2,
}
